var config = {}
// if (process.env.NODE_ENV === 'development') {
//   config = {
//     SITE_TITLE: '国花瓷消费者服务',
//     env: 'development',
//     baseUrl: 'http://natapp.eqiqu.mobi',
//     // apiBaseUrl: 'http://192.168.2.148:8002',
//     // apiBaseUrl: 'http://192.168.31.123:8002',
//     // apiBaseUrl: 'http://127.0.0.1:8002',
//     apiBaseUrl: 'http://guohuaci.natapp1.cc',
//     // apiBaseUrl: 'http://guohuaci-test.qumahudong.com',
//     // qrReg: /^http:////natapp/.eqiqu/.mobi//([a-zA-Z0-9-_=]+)$/,
//     // apiBaseUrl: 'https://guohuaci-api.qumahudong.com/customer-api',
//     appId: 'wxf83d4f81e7822159',
//     shopMpAppId: 'wx027b1a889654cd4e',
//     // creditStoreBaseUrl: 'http://192.168.2.148:8083',
//     // creditStoreAppId: 'xxx',
//     // creditStoreBackendUrl: 'http://192.168.1.101.8003',
//     creditStoreBaseUrl: 'http://jf.qumahudong.com',
//     creditStoreAppId: 'e26a2f355c65f6aecb535ffe128f2196',
//     creditStoreBackendUrl: 'http://jf-admin.qumahudong.com',
//     gaodeApiKey: '20ea3ece70f429b47fabe83ddeb1a980',
//     xcToken: 'c612e1b2d1c9ccf3801cbe1c024a372a',
//     xcAppSecretKey: 'IiRuEowpC29iYiTywyn1ETO2C1CqYoyY',
//     xcBaseUrl: 'https://kernel.services.xingchen.cn/open/',
//     xcMToken: 'e7c308657e86c4b84c7eb900a2e7afeb'
//   }
if (process.env.NODE_ENV === 'development') {
  config = {
    SITE_TITLE: '国花瓷消费者服务',
    env: 'production',
    baseUrl: 'http://g-test.qumahudong.com',
    // apiBaseUrl: 'https://guohuaci-admin.qumahudong.com/',
    apiBaseUrl: 'http://114.132.86.59:8004/',
    // qrReg: /^http:\/\/guohuaci.qumahudong.com\/([a-zA-Z0-9-_=]+)$/,
    appId: 'wx6a00dd5916786bf0',
    shopMpAppId: 'wx3a8e4acc52248a02',
    mchId: '1631189156', // 商户号
    creditStoreBaseUrl: 'http://jf.qumahudong.com',
    creditStoreAppId: 'e26a2f355c65f6aecb535ffe128f2196',
    creditStoreBackendUrl: 'https://jf-admin.qumahudong.com',
    gaodeApiKey: '20ea3ece70f429b47fabe83ddeb1a980',
    xcToken: 'c612e1b2d1c9ccf3801cbe1c024a372a',
    xcAppSecretKey: 'IiRuEowpC29iYiTywyn1ETO2C1CqYoyY',
    xcBaseUrl: 'https://kernel.services.xingchen.cn/open/',
    xcMToken: 'e7c308657e86c4b84c7eb900a2e7afeb'
  }
} else if (process.env.NODE_ENV === 'production') {
  config = {
    SITE_TITLE: '国花瓷消费者服务',
    env: 'production',
    baseUrl: 'https://guohuaci.qumahudong.com',
    apiBaseUrl: 'https://guohuaci-admin.qumahudong.com/',
    // apiBaseUrl: 'http://114.132.86.59:8004/',
    // qrReg: /^http:\/\/guohuaci.qumahudong.com\/([a-zA-Z0-9-_=]+)$/,
    appId: 'wx6a00dd5916786bf0',
    // shopMpAppId: 'wx3a8e4acc52248a02',
    shopMpAppId: 'wx6a00dd5916786bf0',
    mchId: '1631189156', // 商户号
    creditStoreBaseUrl: 'http://jf.qumahudong.com',
    creditStoreAppId: 'e26a2f355c65f6aecb535ffe128f2196',
    creditStoreBackendUrl: 'https://jf-admin.qumahudong.com',
    gaodeApiKey: '20ea3ece70f429b47fabe83ddeb1a980',
    xcToken: 'c612e1b2d1c9ccf3801cbe1c024a372a',
    xcAppSecretKey: 'IiRuEowpC29iYiTywyn1ETO2C1CqYoyY',
    xcBaseUrl: 'https://kernel.services.xingchen.cn/open/',
    xcMToken: 'e7c308657e86c4b84c7eb900a2e7afeb'
  }
}
export default config



// WEBPACK FOOTER //
// ./src/config/config.js